import { Helmet } from "react-helmet";
type Props = {
  title: string | undefined;
};

function HelmetCustom(props: Props) {
  return (
    <Helmet>
      <title>ACV88.COM Thế Giới Casino Trong Tay Bạn</title>
    </Helmet>
  );
}

export default HelmetCustom;
